import { QUERY_KEYS } from 'api/query-keys';
import { branchOfficeService } from 'ogp/services';
import { useQuery } from 'react-query';
import { GetBranchOfficeResponse } from '../../../services/branch-office-service.types';

export const useGetBranchOffice = (branchOfficeId: string = '') => {
  const queryFn = async () => await branchOfficeService.getBranchOffice(branchOfficeId);
  const options = {
    enabled: branchOfficeId.length > 0,
  };

  return useQuery<
    Promise<GetBranchOfficeResponse['branchOffice']>,
    Error,
    GetBranchOfficeResponse['branchOffice']
  >(QUERY_KEYS.branchOffice(branchOfficeId), queryFn, options);
};
